(function () {
  var KEY = 'bohm_announcement_closed';

  function showEveryLoad(bar) {
    return bar.getAttribute('data-session') === 'true';
  }

  document.addEventListener('click', function (e) {
    var bar = e.target.closest && e.target.closest('.announcement-marquee-bar');
    if (!bar) return;

    if (e.target.closest('a[href]')) return;

    e.preventDefault();
    bar.style.display = 'none';

    if (showEveryLoad(bar)) return;

    try {
      localStorage.setItem(KEY, bar.getAttribute('data-announcement') || '');
    } catch (err) {}
  }, true);

  function applyClosed() {
    var bar = document.querySelector('.announcement-marquee-bar');
    if (!bar) return;
    if (showEveryLoad(bar)) return;

    try {
      var id = bar.getAttribute('data-announcement') || '';
      if (id && localStorage.getItem(KEY) === id) bar.style.display = 'none';
    } catch (err) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyClosed);
  else applyClosed();
})();